var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    width: 33,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.192 13.064c-.604-1.87-1.232-3.04-1.857-4.902-.062-.185-.3-.31-.505-.498.012-.038.01-.2.09-.291.193-.214.403-.505.644-.549a.796.796 0 01.641.401c.624 1.484 1.233 2.975 1.768 4.492.335.952.605 1.926.806 2.915.199.967-.12 1.319-1.1 1.384a2.044 2.044 0 01-1.003-.088c-1.879-.928-3.735-1.902-5.734-2.944.766-.48 1.323-.614 1.978-.21.746.472 2.223 1 3.034 1.346C22.774 3.99 12.344-.08.05 2.143c1.507-.984 7.858-1.345 11.676-.716A28.044 28.044 0 0122.65 5.6c3.31 2.144 6.392 4.158 8.542 7.465z",
    fill: "#5fb846"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/components/green-arrow-right-96cd022c1299b381cef13e283a585fb7.svg";
export { SvgGreenArrowRight as Component };